import { IUpdateStatusRequisicaoCompraUseCase } from "../../../presentation/useCases/update/update_status_requisicao_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateStatusRequisicaoCompraUseCase
 */

export class UpdateStatusRequisicaoCompraUseCase implements IUpdateStatusRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateStatusRequisicaoCompra(
    idRequisicaoCompra: number,
    status: number,
  ): Promise<void> {
    await this.repository.updateStatusRequisicaoCompra(idRequisicaoCompra, status);
  }
}
